import { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const OptionsTitle = ({
  children
}) => {
  return /*#__PURE__*/_jsx(Text, {
    typography: "heading-50",
    children: children
  });
};
export const useCatalogOptions = () => {
  const history = useHistory();
  return useMemo(() => {
    const handleCategoryOptionClick = category => {
      history.push(`/results?cat=${encodeURIComponent(category)}`);
    };
    const handleToolOptionClick = tool => {
      history.push(`/results?tools=${encodeURIComponent(tool)}`);
    };
    return [
    // Categories
    {
      label: /*#__PURE__*/_jsx(OptionsTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.title.categories"
        })
      })
    }, {
      'data-test-id': 'option-MARKETING',
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.marketing"
      }),
      options: [{
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.allMarketing"
        }),
        onClick: () => {
          handleCategoryOptionClick('MARKETING');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.automation"
        }),
        onClick: () => {
          handleCategoryOptionClick('AUTOMATION');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.contactManagement"
        }),
        onClick: () => {
          handleCategoryOptionClick('CONTACT_MANAGEMENT');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.contentMarketing"
        }),
        onClick: () => {
          handleCategoryOptionClick('CONTENT_MARKETING');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.emailMarketing"
        }),
        onClick: () => {
          handleCategoryOptionClick('EMAIL_MARKETING');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.inboundMarketing"
        }),
        onClick: () => {
          handleCategoryOptionClick('INBOUND_MARKETING');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.leadGeneration"
        }),
        onClick: () => {
          handleCategoryOptionClick('LEAD_GENERATION');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.reportingAndPerformance"
        }),
        onClick: () => {
          handleCategoryOptionClick('REPORTING_AND_PERFORMANCE');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.seo"
        }),
        onClick: () => {
          handleCategoryOptionClick('SEO');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.socialMedia"
        }),
        onClick: () => {
          handleCategoryOptionClick('SOCIAL_MEDIA');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.webDesign"
        }),
        onClick: () => {
          handleCategoryOptionClick('WEBSITE_DESIGN');
        }
      }]
    }, {
      'data-test-id': 'option-SALES',
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.sales"
      }),
      options: [{
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.allSales"
        }),
        onClick: () => {
          handleCategoryOptionClick('SALES');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.contactManagement"
        }),
        onClick: () => {
          handleCategoryOptionClick('CONTACT_MANAGEMENT_SALES');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.inboundSales"
        }),
        onClick: () => {
          handleCategoryOptionClick('INBOUND_SALES');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.salesEnablement"
        }),
        onClick: () => {
          handleCategoryOptionClick('SALES_ENABLEMENT');
        }
      }]
    }, {
      'data-test-id': 'option-SERVICE',
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.service"
      }),
      options: [{
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.allService"
        }),
        onClick: () => {
          handleCategoryOptionClick('SERVICE');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.contactManagement"
        }),
        onClick: () => {
          handleCategoryOptionClick('CONTACT_MANAGEMENT_SERVICE');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.inboundService"
        }),
        onClick: () => {
          handleCategoryOptionClick('INBOUND_SERVICE');
        }
      }]
    }, {
      'data-test-id': 'option-ARTIFICIAL_INTELLIGENCE',
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.artificialIntelligence"
      }),
      onClick: () => {
        handleCategoryOptionClick('ARTIFICIAL_INTELLIGENCE');
      }
    }, {
      'data-test-id': 'option-WEB_DESIGN',
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.webDesign"
      }),
      onClick: () => {
        handleCategoryOptionClick('WEB_DESIGN');
      }
    }, {
      'data-test-id': 'option-OPERATIONS',
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.operations"
      }),
      onClick: () => {
        handleCategoryOptionClick('OPERATIONS');
      }
    }, {
      'data-test-id': 'option-WEB_DEVELOPMENT',
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.webDevelopment"
      }),
      onClick: () => {
        handleCategoryOptionClick('WEB_DEVELOPMENT');
      }
    }, {
      'data-test-id': 'option-DATA_PRIVACY',
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.dataPrivacy"
      }),
      onClick: () => {
        handleCategoryOptionClick('DATA_PRIVACY');
      }
    },
    // HubSpot Software
    {
      label: /*#__PURE__*/_jsx(OptionsTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.title.hubSpotSoftware"
        })
      })
    }, {
      'data-test-id': 'option-MARKETING_HUB_TOOLS',
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.marketing"
      }),
      options: [{
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.allMarketing"
        }),
        onClick: () => {
          handleToolOptionClick('MARKETING_HUB_TOOLS');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.ads"
        }),
        onClick: () => {
          handleToolOptionClick('ADS');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.blogs"
        }),
        onClick: () => {
          handleToolOptionClick('BLOGS');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.campaigns"
        }),
        onClick: () => {
          handleToolOptionClick('CAMPAIGNS');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.cta"
        }),
        onClick: () => {
          handleToolOptionClick('CTA');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.designManager"
        }),
        onClick: () => {
          handleToolOptionClick('DESIGN_MANAGER');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.email"
        }),
        onClick: () => {
          handleToolOptionClick('EMAIL');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.forms"
        }),
        onClick: () => {
          handleToolOptionClick('FORMS');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.landingPage"
        }),
        onClick: () => {
          handleToolOptionClick('LANDING_PAGE');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.lists"
        }),
        onClick: () => {
          handleToolOptionClick('LISTS');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.contacts"
        }),
        onClick: () => {
          handleToolOptionClick('MARKETING_CONTACTS');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.crm"
        }),
        onClick: () => {
          handleToolOptionClick('MARKETING_CRM');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.reports"
        }),
        onClick: () => {
          handleToolOptionClick('MARKETING_REPORTS');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.seo"
        }),
        onClick: () => {
          handleToolOptionClick('SEO');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.social"
        }),
        onClick: () => {
          handleToolOptionClick('SOCIAL');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.templates"
        }),
        onClick: () => {
          handleToolOptionClick('TEMPLATES');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.website"
        }),
        onClick: () => {
          handleToolOptionClick('WEBSITE');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.workflows"
        }),
        onClick: () => {
          handleToolOptionClick('WORKFLOWS');
        }
      }]
    }, {
      'data-test-id': 'option-SALES_HUB_TOOLS',
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.sales"
      }),
      options: [{
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.allSales"
        }),
        onClick: () => {
          handleToolOptionClick('SALES_HUB_TOOLS');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.deals"
        }),
        onClick: () => {
          handleToolOptionClick('DEALS');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.documents"
        }),
        onClick: () => {
          handleToolOptionClick('DOCUMENTS');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.meetings"
        }),
        onClick: () => {
          handleToolOptionClick('MEETINGS');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.prospecting"
        }),
        onClick: () => {
          handleToolOptionClick('PROSPECTING');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.contacts"
        }),
        onClick: () => {
          handleToolOptionClick('SALES_CONTACTS');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.reports"
        }),
        onClick: () => {
          handleToolOptionClick('SALES_REPORTS');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.salesSnippets"
        }),
        onClick: () => {
          handleToolOptionClick('SALES_SNIPPETS');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.sequences"
        }),
        onClick: () => {
          handleToolOptionClick('SEQUENCES');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.tasks"
        }),
        onClick: () => {
          handleToolOptionClick('TASKS');
        }
      }]
    }, {
      'data-test-id': 'option-SERVICE_HUB_TOOLS',
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.service"
      }),
      options: [{
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.allService"
        }),
        onClick: () => {
          handleToolOptionClick('SERVICE_HUB_TOOLS');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.automation"
        }),
        onClick: () => {
          handleToolOptionClick('AUTOMATION');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.customerFeedback"
        }),
        onClick: () => {
          handleToolOptionClick('CUSTOMER_FEEDBACK');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.knowledgeBase"
        }),
        onClick: () => {
          handleToolOptionClick('KNOWLEDGE_BASE');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.contacts"
        }),
        onClick: () => {
          handleToolOptionClick('SERVICE_HUB_CONTACTS');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.crm"
        }),
        onClick: () => {
          handleToolOptionClick('SERVICE_HUB_CRM');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.reports"
        }),
        onClick: () => {
          handleToolOptionClick('SERVICE_HUB_REPORTS');
        }
      }, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.tickets"
        }),
        onClick: () => {
          handleToolOptionClick('TICKETS');
        }
      }]
    }, {
      'data-test-id': 'option-HUBSPOT_CMS',
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.hubspotCms"
      }),
      onClick: () => {
        handleToolOptionClick('HUBSPOT_CMS');
      }
    }, {
      'data-test-id': 'option-DEVELOPER_TOOLS',
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.developerTools"
      }),
      onClick: () => {
        handleToolOptionClick('DEVELOPER_TOOLS');
      }
    }, {
      'data-test-id': 'option-ACCOUNT_SETUP',
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.accountSetup"
      }),
      onClick: () => {
        handleToolOptionClick('ACCOUNT_SETUP');
      }
    }, {
      'data-test-id': 'option-BREEZE_AI',
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.breezeAi"
      }),
      onClick: () => {
        handleToolOptionClick('BREEZE_AI');
      }
    }, {
      'data-test-id': 'option-INTEGRATIONS',
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academy-navigation-lib.ACPage.header.catalogDropdown.options.integrations"
      }),
      onClick: () => {
        handleToolOptionClick('INTEGRATIONS');
      }
    }];
  }, [history]);
};